import "./style.scss";

import React, { FC, useState } from "react";

import { ASSISTANCE_PRICING, Pricing } from "shared/config/pricings";
import Button from "shared/ui/Button";
import { Button_Style } from "shared/ui/Button/Button";
import Modal from "shared/ui/Modal";
import DetailOffre from "components/DetailOffre";
import OffreAccompagnementLigne from "features/accompaniment/components/OffreAccompagnementLigne";

interface IDAssistantPricingProps {
    steps: any;
    setDatas: (data: any) => void;
    datas: any;
    handlePreviousStep: () => void;
    handleNextStep: () => void;
}

const IDAssistantPricing: FC<IDAssistantPricingProps> = ({ setDatas, datas, steps, handlePreviousStep, handleNextStep }) => {
    // `freeze` retire de la vente les offres remplacées (BASIC, STANDARD,
    // PREMIUM) sans les supprimer : les clients qui les détiennent les voient
    // toujours sur leur profil.
    const offres = ASSISTANCE_PRICING.filter((plan) => !plan.freeze);
    const choisi: Pricing | undefined = datas?.chosenPlan;
    const [detail, setDetail] = useState<Pricing | null>(null);

    return (
        <div className="IDAssistantPricing w-100 h-100 d-flex flex-column align-items-center justify-content-between">
            <div className="w-100 text-center">
                <h3>Trouvez le plan pour votre accompagnement</h3>
            </div>

            <div className="IDAssistantPricing__liste w-100">
                {offres.map((plan, i) => (
                    <OffreAccompagnementLigne
                        key={i}
                        plan={plan}
                        selectionnee={choisi?.title === plan.title}
                        onSelect={() => setDatas({ ...datas, chosenPlan: plan })}
                        onEnSavoirPlus={() => setDetail(plan)}
                    />
                ))}
            </div>

            <div className={`d-flex justify-content-${!steps[0].isCurrent ? "between" : "end"} w-100`}>
                {!steps[0].isCurrent && (
                    <Button
                        label={"Retour"}
                        onClick={() => handlePreviousStep()}
                        style={Button_Style.OUTLINED}
                    />
                )}
                <Button
                    disabled={!choisi?.title}
                    label={"Suivant"}
                    onClick={() => handleNextStep()}
                    data-testid="plan-next-button"
                />
            </div>

            {detail && (
                <Modal
                    onClose={() => setDetail(null)}
                    isOpen={!!detail}
                    // L'en-tête de la fenêtre reste vide : la fiche porte déjà
                    // sa pastille et son titre, les répéter alourdissait l'écran.
                    title={""}
                    // Fond blanc plutôt que le gris par défaut : la fiche est une
                    // carte, pas un encart.
                    bgBody={"bg-light"}
                    infoModal={true}
                    type={"info"}>
                    <DetailOffre
                        plan={detail}
                        // Choisir depuis la fiche évite de la refermer pour aller
                        // cliquer la ligne : c'est ici que la décision se prend.
                        onChoisir={() => {
                            setDatas({ ...datas, chosenPlan: detail });
                            setDetail(null);
                        }}
                    />
                </Modal>
            )}
        </div>
    );
};

export default IDAssistantPricing;
